import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';
import { ProgressInfo, StatsProgressBarData } from '../data/stats-progress-bar';

@Injectable()
export class StatsProgressBarService extends StatsProgressBarData {
  private progressInfoData: ProgressInfo[] = [
    {
      title: 'Monthly Billed',
      value: 572900,
      activeProgress: 70,
      description: 'Better than last month (70%)',
    },
    {
      title: 'Receivables',
      value: 6378,
      activeProgress: 30,
      description: 'Better than last month (30%)',
    },
    {
      title: 'Total Kilometers',
      value: 6378,
      activeProgress: 30,
      description: 'Better than last month (30%)',
    },
  ];

  getProgressInfoData(): Observable<ProgressInfo[]> {
    return observableOf(this.progressInfoData);
  }
}
